export default {
  unavailable: {
    title: 'Faturas de cliente não disponíveis',
    description:
      'Os clientes que fazem encomendas nos seus restaurantes não podem solicitar uma fatura, pelo que não há nada a configurar aqui. Os recibos de encomenda e as faturas emitidas pelo seu fornecedor não são afetados.',
  },
};
